import React from "react";
import styled from "styled-components";
import { queryAnimation } from "./Animations";

const QueryLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${(props) => (props.height ? props.height : "calc(100vh - 75px)")};
  background: ${(props) => props.theme.purple};
  @media (max-width: 1100px) {
    height: calc(100vh - 50px);
  }
  img {
    opacity: 0;
    width: 20vw;
    height: 20vw;
    animation: 2000ms ${queryAnimation} 300ms linear infinite;
  }
`;

const QueryLoading = (props) => {
  return (
    <QueryLoadingWrapper width={props.width}>
      <img src="/adam_logo.png" alt="" />
    </QueryLoadingWrapper>
  );
};

export default QueryLoading;
